module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: {
      'text-holder-wrapper': _vm.content === undefined,
        'center': _vm.center
    },
    style: (_vm.styleObj)
  }, [(!_vm.content) ? _c('div', {
    staticClass: "text-holder"
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0f65cbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextHolder.vue
// module id = 468
// module chunks = 2